import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Box from "../base/Box"
import Text from "../base/Text"
import Image from "../base/Image"
import Container from "../UI/Container"
import FooterWrapper, { BgImageWrapper } from "./footer.style"
import FooterBG from "../../assets/images/footer-bg.svg"

const Footer = ({ row, col, colOne, colTwo, titleStyle }) => {
  const Data = useStaticQuery(graphql`
    query {
      dataJson {
        Language_NAMES {
          label
          value
        }
      }
    }
  `)

  return (
    <FooterWrapper id="footerSection">
      {/* <ContactSections /> */}
      <BgImageWrapper>
        <Image src={FooterBG} alt="Footer background" />
      </BgImageWrapper>
      <Container noGutter mobileGutter width="1200px">
        <Box className="row mainRow" {...row}>
          <Box {...colOne} className="row verticalCenter">
            {/* <Heading content="Language" {...titleStyle} /> */}
            {/* //to replace with apizoom comp */}
            {/* <Select
              options={Data.dataJson.Language_NAMES}
              placeholder="Français"
              className="Language_search_select"
              aria-label="Language_search_input"
              isSearchable={false}
            /> */}
            <Box className="copyRight verticalCenter" {...row}>
              <Text
                content={`Copyright ${new Date().getFullYear()} @Appidev.`}
                className="copyRightText"
              />
            </Box>
          </Box>

          {/* End of footer logo column */}
        </Box>
      </Container>
    </FooterWrapper>
  )
}

// Footer style props
Footer.propTypes = {
  row: PropTypes.object,
  col: PropTypes.object,
  colOne: PropTypes.object,
  colTwo: PropTypes.object,
  titleStyle: PropTypes.object,
  textStyle: PropTypes.object,
}

// Footer default style
Footer.defaultProps = {
  // Footer row default style
  row: {
    flexBox: true,
    flexWrap: "wrap",
    ml: "-4px",
    mr: "-4px",
  },
  // Footer col one style
  colOne: {
    width: ["100%", "30%", "33%", "33%"],
    mb: ["30px", 0],
    pl: ["0px", 0],
    pr: ["0px", "0px", 0],
  },
  // Footer col two style
  colTwo: {
    width: ["100%", "70%", "67%", "67%"],
    flexBox: true,
    flexWrap: "wrap",
  },
  // Footer col default style
  col: {
    width: ["100%", 1 / 3, 1 / 3, 1 / 3],
    pl: [0, "15px"],
    pr: [0, "15px"],
    mb: ["30px", "30px"],
  },
  // widget title default style
  titleStyle: {
    color: "#FFFFFF",
    fontSize: ["15px", "16px", "16px", "18px", "18px"],
    fontWeight: "600",
    lineHeight: "1.34",
    mb: ["15px", "18px", "18px", "20px", "30px"],
    fontFamily: "Poppins",
  },
  // Default logo size
  logoStyle: {
    width: "128px",
    mb: "15px",
  },
  // widget text default style
  textStyle: {
    color: "#FFFFFF",
    fontSize: "16px",
    mb: "12px",
    fontWeight: "600",
    fontFamily: "Lato",
  },
}

export default Footer
